import { render, staticRenderFns } from "./mcp-documentation.vue?vue&type=template&id=f3ac7c40&scoped=true&"
import script from "./mcp-documentation.vue?vue&type=script&lang=js&"
export * from "./mcp-documentation.vue?vue&type=script&lang=js&"
import style0 from "./mcp-documentation.vue?vue&type=style&index=0&id=f3ac7c40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ac7c40",
  null
  
)

export default component.exports